import React from 'react';
import { Badge } from 'reactstrap';

import { UpstreamToken } from 'upstream-shared/models';

import config from '../../config';
import Header from '../Header';
import Footer from '../Footer';
import Routes from './Routes';
import { StylesDictionary } from '../../theme';

const styles: StylesDictionary = {
  app: {
    // paddingTop: sizes.appHeaderPadding,
    minHeight: '100%',
    minWidth: '960px',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    overflowX: 'auto',
  },
  badge: {
    position: 'fixed',
    top: 5,
    left: 5,
    zIndex: 11,
  },
  page: {
    flex: '1 0 auto',
    boxSizing: 'border-box',
    display: 'flex',
  },
};

interface ContentPageProps {
  authUser?: UpstreamToken;
  authError?: string;
}

const ContentPage = (props: ContentPageProps) => {
  const { authUser, authError } = props;

  const environment = config.UPSTREAM_ENV === 'prod' ? 'Beta' : config.UPSTREAM_ENV;

  return (
    <div className={'contentPage'}>
      <Header authUser={authUser} />
      <Badge color={'warning'} style={styles.badge}>
        {environment} Version
      </Badge>
      <div className={'contentPageMain'}>
        <Routes authUser={authUser} authError={authError} />
      </div>
      <Footer />
    </div>
  );
};

export default ContentPage;

// {/*Save for prod release*/}
// {/*{config.UPSTREAM_ENV !== 'prod' && (*/}
// {/*  <Badge color={'warning'} style={styles.badge}>*/}
// {/*    Environment: {config.UPSTREAM_ENV}*/}
// {/*  </Badge>*/}
// {/*)}*/}
